import { ICON_TYPES } from '../constants';

export const OutdoorShowerIcon = (): JSX.Element => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g>
        <path
          d="M20.5433 14.1145L20.9956 10.4999H2.625V4.22877C2.625 3.34415 3.34425 2.6249 4.22888 2.6249C4.73113 2.6249 5.21063 2.86465 5.5125 3.26627L5.98588 3.89715L5.58688 6.18352L6.524 7.64477L11.5789 3.8534L10.6418 2.39215L8.05175 2.27665L7.61163 1.6904C6.81713 0.631649 5.55188 -0.000976562 4.22888 -0.000976562C1.897 -0.000101562 0 1.8969 0 4.22877V10.4999L0.4795 14.1136C0.685125 15.7604 1.46825 17.2129 2.60925 18.2769L1.9285 20.9999H4.634L4.95513 19.7154C5.68663 19.9805 6.47238 20.1249 7.28875 20.1249H13.7331C14.5416 20.1249 15.3213 19.9832 16.0466 19.7224L16.366 20.9999H19.0715L18.3951 18.2935C19.5458 17.2278 20.3359 15.7691 20.5433 14.1145ZM7.28963 17.4999C5.15638 17.4999 3.34863 15.9048 3.08438 13.7881L3.00125 13.1249H18.0215L17.9384 13.789C17.6741 15.9048 15.8664 17.4999 13.7331 17.4999H7.28875H7.28963Z"
          fill="#43494F"
        />
      </g>
    </svg>
  );
};

OutdoorShowerIcon.iconType = ICON_TYPES.OUTDOOR_SHOWER;
